import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Segment,
  Dropdown,
  Button
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const ModEditDiscountUX = (props: any) => {
    return(
      <div
        id="ModEditDiscountUX-div-0"
        style={{ width : "100%", height: "100%" ,cursor: "pointer",overflow: "visible",}}>
        <Segment
          id="ModEditDiscountUX-Segment-1">
          <div
            id="ModEditDiscountUX-div-2"
            style={{display: "flex", justifyContent: "space-between"}}>
            
            <div
              id="ModEditDiscountUX-div-3"
              style={{fontWeight: "bold", fontSize: "1.2rem"}}>
              {props.languageUX === "en" ? "Edit discount details" : "แก้ไขรายละเอียดส่วนลด"}
            </div>
            <div
              id="ModEditDiscountUX-div-12"
              style={{cursor: "pointer"}}>
              
            </div>
          </div>
          <hr
            id="ModEditDiscountUX-hr-6">
          </hr>
          <div
            id="ModEditDiscountUX-div-36"
            style={{margin:"10px 0 10px 0"}}>
            {props.errorMessageAdd}
          </div>
          <div
            id="ModEditDiscountUX-div-21"
            style={{display: props.hideSelectCoverage ? "none" : "flex",justifyContent: "space-between", margin: "15px 0px"}}>
            
            <div
              id="ModEditDiscountUX-div-22"
              style={{fontWeight: "bold", fontSize: "1rem", display: "flex", alignItems: "center"}}>
              {props.languageUX === "en" ? "Select discount rights" : "เลือกสิทธิส่วนลด"}
            </div>
            <div
              id="ModEditDiscountUX-div-23"
              style={{width:"75%",marginRight:"5px"}}>
              
              <Dropdown
                clearable={true}
                fluid={true}
                id="ModEditDiscount-Dropdown-Coverage"
                onChange={props.handleChangeValue("coverage")}
                options={props.coverageOptions}
                search={true}
                selection={true}
                value={props.coverage}>
              </Dropdown>
            </div>
            <div
              id="ModEditDiscountUX-div-24">
              {props.buttonAddCoverage}
            </div>
          </div>
          <hr
            id="ModEditDiscountUX-hr-26">
          </hr>
          <div
            id="ModEditDiscountUX-div-27"
            style={{display: props.showEdit ?"flex" :"none", justifyContent: "space-between",margin:"15px 0 15px 0"}}>
            
            <div
              id="ModEditDiscountUX-div-28"
              style={{fontWeight: "bold", fontSize: "1rem", display: "flex", alignItems: "center"}}>
              {props.languageUX === "en" ? "Edit discount according to rights" : "แก้ไขส่วนลดตามสิทธิ"}
            </div>
            <div
              id="ModEditDiscountUX-div-29"
              style={{width:"85%"}}>
              
              <Dropdown
                clearable={true}
                fluid={true}
                id="ModEditDiscountUX-Dropdown-30"
                onChange={props.handleChangeValue("discountByCoverageCode")}
                options={props.discountOptions}
                selection={true}
                value={props.discountByCoverageCode}>
              </Dropdown>
            </div>
          </div>
          <div
            id="ModEditDiscountUX-div-15"
            style={{display:props.showEdit ?"" :"none"}}>
            
            <Table
              data={props.orderList}
              getTdProps={props.getTdProps}
              headers="หมวดหรือสินค้า,ประเภท,ราคาลด,ร้อยละ,วิธีการคำนวณ,"
              id="ModEditDiscountUX-Table-38"
              keys="name,encounter_type,amount,percent,calculation,delete"
              minRows="7"
              showPagination={false}
              style={{height:"300px"}}>
            </Table>
          </div>
          <div
            id="ModEditDiscountUX-div-37"
            style={{margin:"10px 0 10px 0"}}>
            {props.errorMessageSave}
          </div>
          <div
            id="ModEditDiscountUX-div-18"
            style={{display: props.showEdit ?"flex" :"none", margin:"15px 0px"}}>
            
            <div
              id="ModEditDiscountUX-div-19">
              {props.buttonBillProduct}
            </div>
            <div
              id="ModEditDiscountUX-div-31">
              {props.buttonBillMode}
            </div>
            <Button
              color="blue"
              id="ModEditDiscountUX-Button-32"
              onClick={props.onAddProduct}
              size="small">
              {props.languageUX === "en" ? "ADD PRODUCT" : "เพิ่มรายการใหม่"}
            </Button>
            <Button
              color="blue"
              id="ModEditDiscountUX-Button-34"
              onClick={props.onAddBillMode}
              size="small">
              {props.languageUX === "en" ? "ADD BILL MODE" : "เพิ่มหมวดค่าใช้จ่ายหมวดใหม่"}
            </Button>
            <div
              id="ModEditDiscountUX-div-39"
              style={{flex:"1"}}>
              
            </div>
            <div
              id="ModEditDiscountUX-div-35">
              {props.buttonSave}
            </div>
          </div>
        </Segment>
      </div>
    )
}


export default ModEditDiscountUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Wed Sep 17 2025 11:36:56 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width : \"100%\", height: \"100%\" ,cursor: \"pointer\",overflow: \"visible\",}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Segment",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-Segment-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "แก้ไขรายละเอียดส่วนลด",
          "valueEN": "Edit discount details"
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-hr-6"
        }
      },
      "seq": 6,
      "void": true
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{display:props.showEdit ?\"\" :\"none\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showEdit ?\"flex\" :\"none\", margin:\"15px 0px\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonBillProduct"
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-19"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideSelectCoverage ? \"none\" : \"flex\",justifyContent: \"space-between\", margin: \"15px 0px\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกสิทธิส่วนลด",
          "valueEN": "Select discount rights"
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1rem\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{width:\"75%\",marginRight:\"5px\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonAddCoverage"
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-24"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Dropdown",
      "parent": 23,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscount-Dropdown-Coverage"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"coverage\")"
        },
        "options": {
          "type": "code",
          "value": "props.coverageOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.coverage"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-hr-26"
        }
      },
      "seq": 21,
      "void": true
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showEdit ?\"flex\" :\"none\", justifyContent: \"space-between\",margin:\"15px 0 15px 0\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "แก้ไขส่วนลดตามสิทธิ",
          "valueEN": "Edit discount according to rights"
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1rem\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{width:\"85%\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Dropdown",
      "parent": 29,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-Dropdown-30"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"discountByCoverageCode\")"
        },
        "options": {
          "type": "code",
          "value": "props.discountOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.discountByCoverageCode"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonBillMode"
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-31"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Button",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มรายการใหม่",
          "valueEN": "ADD PRODUCT"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-Button-32"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddProduct"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Button",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มหมวดค่าใช้จ่ายหมวดใหม่",
          "valueEN": "ADD BILL MODE"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-Button-34"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddBillMode"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-35"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.errorMessageAdd"
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-36"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px 0 10px 0\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.errorMessageSave"
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px 0 10px 0\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 38,
      "name": "Table",
      "parent": 15,
      "props": {
        "data": {
          "type": "code",
          "value": "props.orderList"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.getTdProps"
        },
        "headers": {
          "type": "value",
          "value": "หมวดหรือสินค้า,ประเภท,ราคาลด,ร้อยละ,วิธีการคำนวณ,"
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-Table-38"
        },
        "keys": {
          "type": "value",
          "value": "name,encounter_type,amount,percent,calculation,delete"
        },
        "minRows": {
          "type": "value",
          "value": "7"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height:\"300px\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 35,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "ModEditDiscountUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
